<script lang="ts">
	//Hooks
	import { format } from 'svelte-i18n';
	import { onMount, getContext } from 'svelte';
	//Design system components
	import { IconButton } from '@Shelly/shelly-design-system';
	//Config
	import { mapbox_map_config } from '../../../helpers/geolocalion_helper';
	//Types
	import type { MapContext } from '../../../types/requests/services/weather';

	const { getMap }: MapContext = getContext('map'),
		map = getMap();

	let zoom = 12,
		duration = 0.5;

	onMount(() => {
		onZoom();
		map.on('zoom', onZoom);
		return () => map.off('zoom', onZoom);
	});

	const onZoom = () => {
		zoom = map.getZoom();
	};
	const zoomTo = (zoom: number) => {
		map.flyTo({
			zoom,
			curve: 2,
			speed: 0.6,
			easing: (t) => t,
		});
	};
	const zoomIn = () => {
		zoomTo(zoom + duration);
	};
	const zoomOut = () => {
		zoomTo(zoom - duration);
	};
</script>

<div class="zoom-in-btn">
	<IconButton
		variant="secondary"
		disabled={Number(zoom.toFixed(3)) >= mapbox_map_config.maxZoom}
		icon="fas fa-plus"
		aria-label={$format('label_zoom_in', { default: 'Zoom in' })}
		on:click={zoomIn}
	/>
</div>
<div class="zoom-out-btn">
	<IconButton
		variant="secondary"
		disabled={Number(zoom.toFixed(3)) <= mapbox_map_config.minZoom}
		icon="fas fa-minus"
		aria-label={$format('label_zoom_out', { default: 'Zoom out' })}
		on:click={zoomOut}
	/>
</div>

<style>
	.zoom-in-btn,
	.zoom-out-btn {
		position: absolute;
		bottom: 80px;
		right: 10px;
		box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.75);
		border-radius: var(--radius-small);
		z-index: 3;
	}
	.zoom-in-btn {
		bottom: 120px;
	}
</style>
